import { render } from "./DialogView.vue?vue&type=template&id=bd28827a"
import script from "./DialogView.vue?vue&type=script&lang=js"
export * from "./DialogView.vue?vue&type=script&lang=js"

import "./DialogView.vue?vue&type=style&index=0&id=bd28827a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__